import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { login } from "../utilities/FetchUtil";
import {
  Button,
  Center,
  Flex,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from "@mantine/core";

export interface signInDetails {
  username: string | undefined;
  password: string | undefined;
}

const Login = () => {
  const navigate = useNavigate();

  const [signInDetails, setSignInDetails] = useState<signInDetails>({
    username: "",
    password: "",
  });
  const [isError, setIsError] = useState(false);
  const [errorText, setErrorText] = useState("Incorrect sign in information.");

  const handleUsernameInput = (input: string) => {
    setSignInDetails((prevState) => ({
      ...prevState,
      username: input,
    }));
  };

  const handlePasswordInput = (input: string) => {
    setSignInDetails((prevState) => ({
      ...prevState,
      password: input,
    }));
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const response = await login(signInDetails);

      if (response.ok) {
        const data = await response.json();
        const { token, createdAt, expiresAt, username } = data;
        localStorage.setItem(
          "jwtToken",
          JSON.stringify({ token, createdAt, expiresAt, username }),
        );
        navigate("/active");
      } else if (response.status >= 500) {
        setErrorText("Server error, please try again later.");
        setIsError(true);
        console.error("Failed to sign in:", response.status);
      } else {
        setErrorText("Incorrect sign in information.");
        setIsError(true);
        console.error("Failed to sign in:", response.status);
      }
    } catch (error) {
      setErrorText("Something went wrong while trying to sign in.");
      setIsError(true);
      console.error("Error:", error);
    }
  };

  return (
    <Center h="75%">
      <Paper shadow="xl" p="xl" radius="md">
        <form onSubmit={handleSubmit}>
          <Flex direction="column" justify="center" gap="md" ta="center">
            <Title order={2} fw={500} className="login-header">
              Sign in
            </Title>
            <Text>You must be signed in to use this application.</Text>
            <Stack ta="left">
              <TextInput
                label="Username"
                required
                wrapperProps={{ display: "block" }}
                name="username"
                autoComplete="on"
                placeholder="Username"
                error={isError}
                value={signInDetails.username}
                onChange={(e) => handleUsernameInput(e.target.value)}
              />
              <PasswordInput
                label="Password"
                required
                wrapperProps={{ display: "block" }}
                name="password"
                placeholder="Password"
                error={isError}
                autoComplete="on"
                value={signInDetails.password}
                onChange={(e) => handlePasswordInput(e.target.value)}
              />
            </Stack>
            <Center h={30}>
              {isError && <Text c="red">{errorText}</Text>}
            </Center>
            <Button type="submit" className="login-button">
              <Title order={4}>Sign in</Title>
            </Button>
          </Flex>
        </form>
      </Paper>
    </Center>
  );
};

export default Login;
